import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import { readJsonNumber } from "../../../../util/json.js";


export class PacketInPong extends PacketIn {
    public clientTimeMs: number | null = null;
    public serverTimeMs: number | null = null;

    constructor() {
        super(InboundPacketType.PONG);
    }

    override readContents(_context: MessageIOContext, json: Record<string, any>): void {
        this.clientTimeMs = readJsonNumber(json, "client_time_ms");
        this.serverTimeMs = readJsonNumber(json, "server_time_ms");
    }
}
